var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "mmhb7lpsta"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.674510 0 0 0 0 0.709804 0 0 0 0 0.741176 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#mmhb7lpsta)",
    transform: "translate(-65 -1355) translate(10 1217) translate(34 127) translate(21 11)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#21252A",
    fillRule: "nonzero",
    d: "M14.11 14.672c.135-.035.252-.103.352-.202.106-.1.174-.219.207-.356.032-.138.032-.274 0-.409-.033-.135-.101-.252-.207-.351l-4.5-4.504 4.5-4.505c.106-.1.174-.217.207-.352.032-.135.032-.27 0-.409-.033-.137-.101-.256-.207-.355-.1-.1-.217-.167-.351-.203-.135-.035-.27-.035-.405 0-.135.036-.252.103-.351.203L8.847 7.736 4.346 3.229c-.1-.1-.218-.167-.356-.203-.138-.035-.274-.035-.409 0-.135.036-.252.103-.351.203-.106.1-.175.218-.207.355-.032.138-.03.274.005.41.035.134.102.251.202.35L7.733 8.85 3.23 13.354c-.1.1-.167.216-.202.351-.036.135-.037.271-.005.409.032.137.101.256.207.356.1.1.216.167.351.202.135.035.271.035.409 0 .138-.035.256-.103.356-.202l4.501-4.506 4.508 4.506c.1.1.216.167.351.202.135.035.27.035.405 0z",
    transform: "translate(0 .5)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDelete);
export default __webpack_public_path__ + "static/media/ic_delete.1f9acf7ab2a77b7bfd8f196d6840c158.svg";
export { ForwardRef as ReactComponent };